import { render } from "./CsvDownloadLink.vue?vue&type=template&id=063459f8"
import script from "./CsvDownloadLink.vue?vue&type=script&lang=js"
export * from "./CsvDownloadLink.vue?vue&type=script&lang=js"
script.render = render

export default script